<app-header-latest></app-header-latest>
    <!-- <div class="row mb-4">
      <div class="col text-center">
        <label class="question-label">Do you have tax documents?</label>

        <mat-radio-group (change)="onTaxOptionChange($event.value)">
          <mat-radio-button value="yes" class="me-3">Yes</mat-radio-button>
          <mat-radio-button value="no">No</mat-radio-button>
        </mat-radio-group>
      </div>
    </div> -->
<section *ngIf="!uploadSuccess" class="doc-upload">

  <div class="doc-upload__card">

    <form [formGroup]="form" class="doc-upload__form">

      <!-- GST -->
      <div class="doc-row">
        <div class="doc-row__input">

          <mat-form-field appearance="outline">
            <mat-label>GST Number</mat-label>

            <input matInput formControlName="gstNumber" placeholder="Enter GST number">

            <mat-error *ngIf="form.get('gstNumber')?.hasError('required')">
              Field is required
            </mat-error>

            <mat-error *ngIf="form.get('gstNumber')?.hasError('invalidGst')">
              Input valid GSTIN format (e.g., 27ABCDE1234F1Z2)
            </mat-error>

          </mat-form-field>

        </div>

        <div class="doc-row__upload">

          <button class="btn btn-solid upload-btn" mat-fab extended (click)="gstInput.click()">
            <mat-icon>cloud_upload</mat-icon>
            Upload File
            <input type="file" #gstInput hidden (change)="handleFileInput($event,'gst')"
              [disabled]="form.get('gstNumber')?.disabled">
          </button>

          <span class="doc-row__reason" *ngIf="uploadedFiles['gst']?.comments">
            Reason: {{uploadedFiles['gst']?.comments}}
          </span>

          <p class="doc-row__file" *ngIf="uploadedFiles['gst']?.fileName">
            {{uploadedFiles['gst']?.fileName}}
          </p>

        </div>
      </div>

      <!-- CIN -->
      <div class="doc-row">

        <div class="doc-row__input">

          <mat-form-field appearance="outline">
            <mat-label>CIN Number</mat-label>

            <input matInput formControlName="cinNumber" placeholder="Enter CIN number">

            <mat-error *ngIf="form.get('cinNumber')?.hasError('required')">
              Field is required
            </mat-error>

            <mat-error *ngIf="form.get('cinNumber')?.hasError('invalidCin')">
              Input valid CIN number format (e.g., U12342MH2000PTC012342)
            </mat-error>

          </mat-form-field>

        </div>

        <div class="doc-row__upload">

          <button class="btn btn-solid upload-btn" mat-fab extended (click)="cinInput.click()">
            <mat-icon>cloud_upload</mat-icon>
            Upload File
            <input type="file" #cinInput hidden (change)="handleFileInput($event,'cin')"
              [disabled]="form.get('cinNumber')?.disabled">
          </button>

          <span class="doc-row__reason" *ngIf="uploadedFiles['cin']?.comments">
            Reason: {{uploadedFiles['cin']?.comments}}
          </span>

          <p class="doc-row__file" *ngIf="uploadedFiles['cin']?.fileName">
            {{uploadedFiles['cin']?.fileName}}
          </p>

        </div>
      </div>

      <!-- PAN -->
      <div class="doc-row">

        <div class="doc-row__input">

          <mat-form-field appearance="outline">
            <mat-label>PAN Number</mat-label>

            <input matInput formControlName="panNumber" placeholder="Enter PAN number">

            <mat-error *ngIf="form.get('panNumber')?.hasError('required')">
              Field is required
            </mat-error>

            <mat-error *ngIf="form.get('panNumber')?.hasError('invalidPan')">
              Input valid PAN number format (e.g., ABCDE1234F)
            </mat-error>

          </mat-form-field>

        </div>

        <div class="doc-row__upload">

          <button class="btn btn-solid upload-btn" mat-fab extended (click)="panInput.click()">
            <mat-icon>cloud_upload</mat-icon>
            Upload File
            <input type="file" #panInput hidden (change)="handleFileInput($event,'pan')"
              [disabled]="form.get('panNumber')?.disabled">
          </button>

          <span class="doc-row__reason" *ngIf="uploadedFiles['pan']?.comments">
            Reason: {{uploadedFiles['pan']?.comments}}
          </span>

          <p class="doc-row__file" *ngIf="uploadedFiles['pan']?.fileName">
            {{uploadedFiles['pan']?.fileName}}
          </p>

        </div>
      </div>

      <!-- OTHER -->
      <div class="doc-row">

        <div class="doc-row__input">

          <mat-form-field appearance="outline">
            <mat-label>Document Number</mat-label>

            <input matInput formControlName="otherNumber" placeholder="Enter document number">

            <mat-error *ngIf="form.get('otherNumber')?.hasError('required')">
              Field is required
            </mat-error>

          </mat-form-field>

        </div>

        <div class="doc-row__upload">

          <button class="btn btn-solid upload-btn" mat-fab extended (click)="otherInput.click()">
            <mat-icon>cloud_upload</mat-icon>
            Upload File
            <input type="file" #otherInput hidden (change)="handleFileInput($event,'other')"
              [disabled]="form.get('otherNumber')?.disabled">
          </button>

          <span class="doc-row__reason" *ngIf="uploadedFiles['other']?.comments">
            Reason: {{uploadedFiles['other']?.comments}}
          </span>

          <p class="doc-row__file" *ngIf="uploadedFiles['other']?.fileName">
            {{uploadedFiles['other']?.fileName}}
          </p>

        </div>

      </div>

      <!-- SAVE BUTTON -->
      <div class="row mt-4">
        <div class="col text-center">
          <!-- <a class="skip-link me-3" (click)="onSkip($event)">Skip</a> -->
          <button class="btn btn-solid" (click)="onSubmit()" [disabled]="!isAnyDocumentValid() || isSaving">
            {{ isSaving ? 'Saving...' : 'Save' }}
          </button>
        </div>
      </div>

      <p class="doc-upload__note">
        Note: Only JPEG, JPG, PDF, DOCX or PNG files are allowed.
      </p>

    </form>

  </div>

</section>


<!-- SUCCESS SCREEN -->

<div class="upload-success" *ngIf="uploadSuccess">

  <div class="upload-success__card">

    <div class="upload-success__icon">
      <i class="fa fa-check-circle"></i>
    </div>

    <h2 class="upload-success__title">
      Documents Uploaded Successfully
    </h2>

    <p class="upload-success__message">
      Your account is under review. Please wait for approvals.
    </p>

  </div>

</div>

<!-- <app-footer-more-info></app-footer-more-info> -->
 <app-peopleflow-footer></app-peopleflow-footer>